import { dashbaordData, partyDashbaordData } from "@/api/dashboard";
import store from "@/store";

// Get dashboard data
export const getDashboardData= (commit, payload) => {
  return new Promise((resolve) => {
    dashbaordData(payload).then((response) => {
      if (response.status_code === 200) {
        resolve(response.data);
      }
    });
  });
};

export const getPartyDashboardData= (commit, payload) => {
  return new Promise((resolve) => {
    partyDashbaordData(payload).then((response) => {
      if (response.status_code === 200) {
        store.commit("dashboard/setResponse", response.data);
        resolve(response.data);
      }
    });
  });
};
